import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export function ngbDateStructFromNativeDate (date?: Date): NgbDateStruct {
    if (!date) {
        const today = new Date();
        return {
            year: today.getFullYear(),
            month: today.getMonth() + 1,
            day: today.getDate(),
        };
    }

    return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
    };
}
